export enum EMarqueCompteur {
    Lighthouse = 1,
    TSI,
    ATI,
    PMT = 4
}